module.exports = __webpack_public_path__ + "img/titleid.de1bbe89.png";